import { debounce } from 'lodash';

const SEARCH_DEBOUNCE_MS = 400;

export default {
  data() {
    return {
      paginationState: {}, // { page, hasMore, searchTerm, isLoadingMore }
      searchTerm: '',
    };
  },
  computed: {
    currentPaginationState() {
      if (!this.selectedField) {
        return null;
      }
      return this.paginationState[this.selectedField] || null;
    },
    canLoadMore() {
      const state = this.currentPaginationState;
      return state && state.hasMore && !this.isLoadingOptions;
    },
    isLoadingMore() {
      const state = this.currentPaginationState;

      return state && state.isLoadingMore;
    },
  },
  methods: {
    getPaginationState(field) {
      if (!this.paginationState[field]) {
        this.resetPaginationState(field);
      }

      return this.paginationState[field];
    },
    resetPaginationState(field) {
      this.$set(this.paginationState, field, {
        page: 1,
        hasMore: true,
        searchTerm: '',
        isLoadingMore: false,
      });
    },
    updatePaginationState(field, updates) {
      const currentState = this.getPaginationState(field);
      this.$set(this.paginationState, field, {
        ...currentState,
        ...updates,
      });
    },
    onSearchInput: debounce(function (searchTerm) {
      if (!this.selectedField) {
        return;
      }

      const field = this.selectedField;
      const currentSearch = this.getPaginationState(field).searchTerm;
      const normalizedSearchTerm = typeof searchTerm === 'string' ? searchTerm.trim() : searchTerm;
      const normalizedCurrentSearch = typeof currentSearch === 'string' ? currentSearch.trim() : currentSearch;

      if (normalizedSearchTerm === normalizedCurrentSearch) {
        return;
      }

      const config = this.currentFieldConfig;
      if (!config || config.type !== 'select' || !config.fetchOptions) {
        return;
      }

      this.selectOptions = [];

      this.updatePaginationState(field, {
        page: 1,
        searchTerm: normalizedSearchTerm,
        hasMore: true,
      });

      this.$nextTick(() => {
        this.loadSelectOptions();
      });
    }, SEARCH_DEBOUNCE_MS),
    onIntersect(entries) {
      if (entries[0].isIntersecting && this.canLoadMore && !this.isLoadingMore) {
        this.loadNextPage();
      }
    },
    async loadNextPage() {
      if (!this.selectedField || !this.canLoadMore) {
        return;
      }

      const field = this.selectedField;
      const state = this.getPaginationState(field);

      this.updatePaginationState(field, {
        page: state.page + 1,
        isLoadingMore: true,
      });

      try {
        await this.loadSelectOptions(false);
      } catch (error) {
        console.error('Error loading next page:', error);
      }
    },
    clearPaginationState() {
      if (this.selectedField) {
        this.resetPaginationState(this.selectedField);
      }
    },
  },
};
